import { isPad, isPc } from './ro-os-check.js';

function initCard(card) {
  const swiperWrapper = card.querySelector('.swiper-wrapper');
  if (!swiperWrapper) return;

  swiperWrapper.addEventListener('click', () => {
    window.location.href = card.dataset.productUrl;
  });
}

function initSwiper(root) {
  if (root.swiper) return;

  const defaultSwiperInterval = `${root.dataset.interval}s`;
  const now = new Date();
  const slides = root.querySelectorAll('.slide');

  slides.forEach((slide) => {
    const { startTime, endTime, mobVideoDuration, pcVideoDuration } = slide.dataset;

    if ((startTime && new Date(startTime) > now) || (endTime && new Date(endTime) < now)) {
      slide.remove();
      return;
    }

    if (isPc()) {
      if (pcVideoDuration) {
        slide.dataset.swiperAutoplay = pcVideoDuration;
      }
    } else if (mobVideoDuration) {
      slide.dataset.swiperAutoplay = mobVideoDuration;
    }
  });

  const swiperOptions = {
    init: false,
    rewind: true,
    effect: 'fade',
    a11y: {
      containerMessage: root.dataset.a11yContainerMessage,
      containerRoleDescriptionMessage: root.dataset.a11yContainerRoleDescriptionMessage,
      itemRoleDescriptionMessage: root.dataset.a11yItemRoleDescriptionMessage,
      prevSlideMessage: root.dataset.a11yPrevSlideMessage,
      nextSlideMessage: root.dataset.a11yNextSlideMessage,
      firstSlideMessage: root.dataset.a11yFirstSlideMessage,
      lastSlideMessage: root.dataset.a11yLastSlideMessage,
      paginationBulletMessage: root.dataset.a11yPaginationBulletMessage,
    },
    pagination: {
      el: `#${root.id} .swiper-pagination`,
      clickable: true,
    },
    navigation: {
      prevEl: `#${root.id} .btn-prev`,
      nextEl: `#${root.id} .btn-next`,
    },
  };

  if (root.dataset.autoplay === 'true') {
    swiperOptions.autoplay = {
      delay: Number(root.dataset.interval) * 1000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false,
    };
  }

  const swiper = new Swiper(root, swiperOptions);

  swiper.on('beforeTransitionStart', pauseVideo);

  swiper.on('slideChangeTransitionStart', () => {
    resetVideo();
  });

  swiper.on('slideChangeTransitionEnd', playVideo);

  swiper.on('init', () => {
    playVideo();
  });

  swiper.init();

  function resetVideo() {
    const slide = swiper.slides[swiper.activeIndex];
    const video = getCurrentSlideVideo();
    const swiperInterval = video ? `${slide.dataset.swiperAutoplay}ms` : defaultSwiperInterval;

    root.style.setProperty('--swiper-interval', swiperInterval);
  }

  function pauseVideo() {
    const video = getCurrentSlideVideo();

    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  }

  function playVideo() {
    const video = getCurrentSlideVideo();

    if (video) {
      video.play();
    }
  }

  function getCurrentSlideVideo() {
    const { slides: swiperSlides, activeIndex } = swiper;
    const slide = swiperSlides[activeIndex];

    lazyLoadVideo(slide);
    lazyLoadVideo(swiperSlides[activeIndex + 1]);

    if (!slide) return null;

    return slide.querySelector('video');
  }

  function lazyLoadVideo(slide) {
    if (!slide || slide.dataset.rendered) return;

    const template = slide.querySelector(isPc() ? '.pc-video' : isPad() ? '.pad-video' : '.mob-video');

    if (template) {
      const video = template.content.cloneNode(true).firstElementChild;

      if (video.poster && video.poster.startsWith('//')) {
        video.setAttribute('poster', location.protocol + video.poster);
      }

      slide.prepend(video);
    }

    slide.dataset.rendered = true;
  }
}

function initPane(container) {
  const cards = Array.from(container.getElementsByClassName('activity-product-swiper-card'));
  if (cards.length === 0) return;

  const tabList = [];
  cards.forEach((card) => {
    const tabId = card.getAttribute('data-tab-id');
    if (tabId) {
      tabList.push(tabId);
    }
  });

  cards.forEach((card, index) => {
    if (container.dataset.bannerType === 'image_right') {
      card.style.flexDirection = 'row-reverse';
    }

    card.style.display = index === 0 ? 'flex' : 'none';
  });

  if (tabList.length <= 1) return;

  tabList.forEach((_, index) => {
    const card = cards[index];
    const currentTabId = card.getAttribute('data-tab-id');
    const navUl = card.querySelector('.product-nav');

    navUl.style.display = 'flex';
    navUl.innerHTML = '';

    tabList.forEach((tab) => {
      const li = document.createElement('li');
      li.className = 'product-nav_item';

      if (tab === currentTabId) {
        li.classList.add('active');
      }

      li.textContent = tab;
      li.setAttribute('data-tab-id', tab);
      navUl.appendChild(li);
    });
  });

  Array.from(container.getElementsByClassName('product-nav_item')).forEach((li) => {
    li.addEventListener('click', (event) => {
      const selectedTabId = event.target.getAttribute('data-tab-id');

      cards.forEach((card) => {
        card.style.display = card.getAttribute('data-tab-id') === selectedTabId ? 'flex' : 'none';
      });
    });
  });
}

function initSwipers() {
  document.querySelectorAll('.activity-product-swiper').forEach(initSwiper);
}

function initDomContent() {
  document.querySelectorAll('.activity-product-swiper-panes-section .activity-product-swiper-card').forEach(initCard);
  initSwipers();
  document.querySelectorAll('.activity-product-swiper-panes-section .activity-product-swiper-pane').forEach(initPane);
}

if (document.readyState === 'complete') {
  initSwipers();
} else {
  document.addEventListener('DOMContentLoaded', initDomContent);
  window.addEventListener('load', initSwipers);
}
